import React from 'react'
import { Page, DropdownItemStyled } from './LanguageSwitcher.styles'
import {
  getLanguages,
  useTranslation,
  SELECTED_LANGUAGE_COOKIE_NAME,
  ONE_YEAR_IN_DAYS
} from 'i18n'
import { useHistory } from 'react-router-dom'
import { setCookieOnDomain } from 'utils/cookies'
import type { User } from 'api/data.types'
import { useUserInfo } from 'utils/hooks/use-userInfo'

export const LanguageSwitcherItems = ({
  onChange
}: {
  onChange?: () => void
}) => {
  const { t, i18n } = useTranslation()
  const { user } = useUserInfo()

  const onChangeLanguage = (selectedLanguage: string) => {
    i18n.changeLanguage(selectedLanguage)

    setCookieOnDomain(
      SELECTED_LANGUAGE_COOKIE_NAME,
      selectedLanguage,
      ONE_YEAR_IN_DAYS
    )

    onChange?.()
  }

  return (
    <>
      {getLanguages(t, user?.isContextNonEducational).map(item => (
        <DropdownItemStyled
          key={item.value}
          text={item.label}
          type="icon-left-text-left"
          iconName={i18n.language === item.value && 'check-circle'}
          aria-current={i18n.language === item.value ? 'true' : undefined}
          onClick={() => {
            onChangeLanguage(item.value)
          }}
        />
      ))}
    </>
  )
}

export function shouldRenderLanguageSwitcher({ reader, teacher }: User) {
  return true
}

const LanguageSwitcher = () => {
  const history = useHistory()

  return (
    <Page data-test="language-switcher">
      <LanguageSwitcherItems
        onChange={() => {
          history.goBack()
        }}
      />
    </Page>
  )
}

export default LanguageSwitcher
